import { render, staticRenderFns } from "./OpeningBalance.vue?vue&type=template&id=1fda03c4"
import script from "./OpeningBalance.vue?vue&type=script&lang=js"
export * from "./OpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./OpeningBalance.vue?vue&type=style&index=0&id=1fda03c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports